import { render, staticRenderFns } from "./MenuItemsCategoryForm.vue?vue&type=template&id=167eed69&"
import script from "./MenuItemsCategoryForm.vue?vue&type=script&lang=js&"
export * from "./MenuItemsCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports